import { useState } from "react";
import { useSnackbar } from 'notistack';
// @mui
import {
  Stack,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// hooks
import useResponsive from '../../../../hooks/useResponsive';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import useAuth from '../../../../hooks/useAuth';
// components
import DIOText from '../../../../components/DIOText';
import {
  PasteDoneCard,
} from "./";
import {
  DIOManagerCallDialog,
} from '../';
// util
import axios from '../../../../utils/axios';

// ----------------------------------------------------------------------

export default function WriteRequestForm({ jobPost, next }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDIOManagerCallDialogOpen, setIsDIOManagerCallDialogOpen] = useState(false);

  const writeRequest = async () => {
    setIsSubmitting(true);
    try {
      const companyId = user?.employee.company[0].id;
      const response = await axios.post(`/api/company/${companyId}/job-posts/${jobPost.id}/write-request/`);
      if (smUp) {
        enqueueSnackbar('저장되었습니다');
      } else {
        enqueueSnackbar('저장되었습니다', {anchorOrigin: { vertical: 'bottom', horizontal: 'center' }});
      }
      if (user?.employee.company[0].need_card && !user?.employee.company[0].save_card) {
        setIsDIOManagerCallDialogOpen(true);
      } else {
        await next(jobPost.id);
      }
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error(err);
      enqueueSnackbar('저장에 실패했습니다. 다시 시도해주세요.', { variant: "error" });
    }
  };

  const closeAndNext = async () => {
    setIsDIOManagerCallDialogOpen(false);
    await next(jobPost.id);
  };

  return (
    <>
      <Stack sx={{ mb: 1 }}>
        <Typography variant="h4" gutterBottom>
          📨 심사 전, 마지막으로 작성하신 내용을 확인해주세요.
        </Typography>
        <Typography variant="body2" sx={{ ...!smUp && { color: 'text.secondary' } }}>
          제출하시면 <DIOText />에서 공고를 검토 후 연락드립니다.
        </Typography>
      </Stack>

      <PasteDoneCard jobPost={jobPost} blueLabel={true} />

      <DIOManagerCallDialog open={isDIOManagerCallDialogOpen} closeDialog={closeAndNext} />

      <LoadingButton
        variant="contained"
        size="large"
        loading={isSubmitting}
        onClick={writeRequest}
        sx={{ mt: 3 }}
      >
        제출하기
      </LoadingButton>
    </>
  )
}